import { noop, isEmpty } from 'lodash';
import { browserHistory } from 'common/utils/browserHistory';
import {
  generateUUID,
} from 'common/utils/utils';
import callOrLog from 'src/common/utils/callOrLog';
import { NEW_CLIENT } from 'common/utils/EventTracker/utils/eventConstants';
import {
  SEARCH_PATH,
} from '../constants';
import goToConfirmStep from '../utils/goToConfirmStep';
import goToAddInformationStep from '../utils/goToAddInformationStep';
import getARIdFromPathname from '../utils/getARIdFromPathname';
import STEP_DEFAULTS from './utils/defaults';

const ARtoReferralStepperConfig = {
  steps: [
    {
      ...STEP_DEFAULTS.first,
      title: 'Search Records',
      onStepClick: () => {
        const location = browserHistory.getCurrentLocation();
        const arId = getARIdFromPathname(location.pathname);
        browserHistory.push(`/assistance-requests/${arId}/referrals/${SEARCH_PATH}`);
      },
      onSearchComplete: ({
        contacts,
        formData,
      }) => {
        const location = browserHistory.getCurrentLocation();
        const arId = getARIdFromPathname(location.pathname);
        const context = `assistance-requests/${arId}/referrals`;

        if (!isEmpty(contacts)) {
          return goToConfirmStep({ context, contactData: formData });
        }
        return goToAddInformationStep({ context, contactData: formData });
      },
      onConfirmationComplete: ({
        contactId,
        formData,
        fromIntegration = false,
      }) => {
        const location = browserHistory.getCurrentLocation();
        const arId = getARIdFromPathname(location.pathname);
        const context = `assistance-requests/${arId}/referrals`;

        if (!isEmpty(contactId)) {
          return goToAddInformationStep({ context, contactId });
        }
        return goToAddInformationStep({ context, contactData: formData, fromIntegration });
      },
      routeRegex: /^\/?assistance-requests\/(.*)\/referrals\/new\/(search|confirm)$/,
    },
    {
      ...STEP_DEFAULTS.second,
      title: 'Contact Information',
      onStepClick: noop,
      onStepComplete: ({
        contact = {},
        contactId = null,
        eventTracker = noop,
      }) => {
        const location = browserHistory.getCurrentLocation();
        const arId = getARIdFromPathname(location.pathname);
        const event = contactId ? NEW_CLIENT.createFromArReferral : NEW_CLIENT.updateFromArReferral;
        callOrLog(() => eventTracker(event, null, {
          contact,
        }));

        browserHistory.push(
          `assistance-requests/${arId}/referrals/new/add-service-types`,
        );
      },
      onBackClick: () => {
        const location = browserHistory.getCurrentLocation();
        const arId = getARIdFromPathname(location.pathname);
        browserHistory.push(`/assistance-requests/${arId}/referrals/${SEARCH_PATH}`);
      },
      routeRegex: /^\/?assistance-requests\/(.*)\/referrals\/new\/(add-contact-information)$/,
    },
    {
      id: generateUUID(),
      title: 'Add Referral',
      onStepClick: () => {
        const location = browserHistory.getCurrentLocation();
        const arId = getARIdFromPathname(location.pathname);
        browserHistory.push(`/assistance-requests/${arId}/referrals/new/add-service-types`);
      },
      isStepDisabled: ({
        activeStepIndex = -1,
      }) => activeStepIndex < 2,
      isStepCompleted: ({
        activeStepIndex = -1,
      }) => activeStepIndex > 2,
      routeRegex: /^\/?assistance-requests\/(.*)\/referrals\/new\/(add-service-types|add-supporting-details)$/,
    },
    {
      id: generateUUID(),
      title: 'Review Referral',
      onStepClick: () => {
        const location = browserHistory.getCurrentLocation();
        const arId = getARIdFromPathname(location.pathname);
        browserHistory.push(`/assistance-requests/${arId}/referrals/new/final-review`);
      },
      isStepDisabled: ({
        activeStepIndex = -1,
      }) => activeStepIndex < 3,
      isStepCompleted: () => false,
      routeRegex: /^\/?assistance-requests\/(.*)\/referrals\/new\/(final-review)$/,
    },
  ],
};

export default ARtoReferralStepperConfig;
